import React from 'react'
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material'
import styles from './styles'

type DeleteArticleModalProps = {
  visible: boolean
  onConfirm: () => void
  onCancel: () => void
  text: string
}
const DeleteArticleModal = (props: DeleteArticleModalProps) => {
  const { onCancel, onConfirm, visible, text } = props

  return (
    <Dialog
      onClose={onCancel}
      aria-labelledby="customized-dialog-title"
      open={visible}
    >
      <DialogContent dividers sx={{ gap: 20 }}>
        <Typography style={styles.headerText}>Are you Sure</Typography>
        <Box sx={{ m: 2 }} />
        <Typography>{text}</Typography>
        <Box sx={{ m: 3 }} />
        <Box style={styles.buttonContainer}>
          <Button
            style={styles.cancelButton}
            onClick={onCancel}
          >
            CANCEL
          </Button>
          <Button
            style={styles.trashButton}
            onClick={onConfirm}
          >
            TRASH
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteArticleModal
